import BubbleAptIconUrl from './bubble-apt-icon.png';
import FreeChargeBackgroundImageTingleUrl from './freeChargeBackgroundImage_tingle.png';
import LoginCharacterBubblechatUrl from './loginCharacterBubblechat.png';
import LoginSplashTingleUrl from './loginSplashTingle.png';
import SignInBannerUrl from './signInBanner.png';
import SignInBannerTingleUrl from './signInBanner_tingle.png';
import TosspayIconDarkUrl from './tosspay-icon-dark.png';
import TosspayIconLightUrl from './tosspay-icon-light.png';

export const BubbleAptIcon = BubbleAptIconUrl;
/**
 * 로그인 모달 소셜 모드 히어로 레이어(#2006, Figma 추출, 투명 PNG).
 * Character = 투명 캐릭터 컷아웃(피그마 image fill 그대로), 하단 페이드는 CSS로 처리(테마별 카드색).
 */
export const LoginCharacterBubblechat = LoginCharacterBubblechatUrl;
/** 팅글 로그인 히어로(Figma 1305:111885, 2x). 윙 그래픽+캐릭터+윙 모양 하단 클리핑이 한 장에 합성된 투명 PNG. */
export const LoginSplashTingle = LoginSplashTingleUrl;
export const SignInBanner = SignInBannerUrl;
export const SignInBannerTingle = SignInBannerTingleUrl;
export const FreeChargeBackgroundImageTingle = FreeChargeBackgroundImageTingleUrl;
export const TosspayIconDark = TosspayIconDarkUrl;
export const TosspayIconLight = TosspayIconLightUrl;
